import { Component, Input } from '@angular/core';
import { Router } from "@angular/router";
import { UpsDashboardService } from '../../../../services/upplm.dashboard.service';
import { DASHBOARD_SECTIONS, PLACARD_STATUS } from '../../../../constants/upplm.constants.dashboard';
import { DashboardResponse } from '../../../../api/models/dashboardResponse';
import { Contact } from '../../../../interface/upplm.placardInformation';
import { RouteURLConstants, CommonConstants } from '../../../../constants/upplm.constants';


@Component({
    selector: 'qvadditional-detail',
    template: require('./qvadditional-detail.component.html')
})

export class QVAdditionalDetailComponent {


    @Input() status: any;
    @Input() dashboardData: DashboardResponse;

    locationDetails: boolean = false;
    contactDetails: boolean = false;
    placardDetails: boolean = false;
    pickupDetails: boolean = false;
    notifications: boolean = false;
    placardVerification: boolean = false;
    placardLocation: boolean = false;
    verificationNeeded: boolean = false;
    public showRequestorContact: boolean = false;
    public requestor: Contact = new Contact();
    primary: Contact = new Contact();
    public MultiOffice: string = '';
    public urlImage: string = '';
    public isLockedContainer: string = '';
    public formatedStartDate: string = '';
    public scheduleDays: string[] = [];
    dashboardSections: string[] = [];
    public paramsUrl: string = '?loc=en_US&placardid=';


    constructor(private router: Router,
        private _dashboardService: UpsDashboardService) { }

    ngOnInit() {
        if (typeof this.dashboardData !== 'undefined' && Object.keys(this.dashboardData).length > 0) {
            this.getSections(this.dashboardData.placardStatus);
        }

    }

    ngOnChanges() {
       /*Empty*/
    }

    getSections(status: string) {
        if (status === PLACARD_STATUS.CANCELLED) { //Load 5 or 7 sections depending if status is cancelled
            if (this.dashboardData.isHung) { //If is cancelled and hung, load 7 sections of dashboard
                this.dashboardSections = this._dashboardService.getDashboardSectionsByStatus(status);
            }
            else {//cancelled and not hung, load only 5 sections of the dashboard
                this.dashboardSections = this._dashboardService.getDashboardSectionsByStatus(PLACARD_STATUS.CANCELLED_NO_HUNG);
            }
        }
        else {//Status is not cancelled, proceed with section loading according to status
            this.dashboardSections = this._dashboardService.getDashboardSectionsByStatus(status);
        }

        this.setValueToSections();
        this.getAndCompareContacts();
        this.getMultiOffice();
        this.getURLPicture();
        this.getLockedContainer();
        this.getScheduleDays();
    };

    getScheduleDays() {
        this.scheduleDays = [];
        for (var i = 0; i < this.dashboardData.placardInformation.pickupDetails.selectedDays.length; i++) {
            let d = this.dashboardData.placardInformation.pickupDetails.selectedDays[i];
            let day: string = '';
            if (d.dayOfWeekCode === CommonConstants.SHORT_ORDERED_UPPER_DAYS_OF_WEEK[0]) {
                day = CommonConstants.ORDERED_DAYS_OF_WEEK[0]
            }
            if (d.dayOfWeekCode === CommonConstants.SHORT_ORDERED_UPPER_DAYS_OF_WEEK[1]) {
                day = CommonConstants.ORDERED_DAYS_OF_WEEK[1]
            }
            if (d.dayOfWeekCode === CommonConstants.SHORT_ORDERED_UPPER_DAYS_OF_WEEK[2]) {
                day = CommonConstants.ORDERED_DAYS_OF_WEEK[2]
            }
            if (d.dayOfWeekCode === CommonConstants.SHORT_ORDERED_UPPER_DAYS_OF_WEEK[3]) {
                day = CommonConstants.ORDERED_DAYS_OF_WEEK[3]
            }
            if (d.dayOfWeekCode === CommonConstants.SHORT_ORDERED_UPPER_DAYS_OF_WEEK[4]) {
                day = CommonConstants.ORDERED_DAYS_OF_WEEK[4]
            }
            if (d.dayOfWeekCode === CommonConstants.SHORT_ORDERED_UPPER_DAYS_OF_WEEK[5]) {
                day = CommonConstants.ORDERED_DAYS_OF_WEEK[5]
            }
            if (d.dayOfWeekCode === CommonConstants.SHORT_ORDERED_UPPER_DAYS_OF_WEEK[6]) {
                day = CommonConstants.ORDERED_DAYS_OF_WEEK[6]
            }
            day += ' ' + d.selectedPreferredTime + ' - ' + d.selectedLatestTime;
            this.scheduleDays.push(day);
        }
    }

    getLockedContainer() {
        if (this.dashboardData.placardInformation.placardLocation) {
            this.isLockedContainer = this.dashboardData.placardInformation.placardLocation.metalBoxInd === true ? 'Yes' : 'No';
        }
    }

    setValueToSections() {
        this.locationDetails = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.LOCATION_DETAILS) > -1 ? true : false;
        this.contactDetails = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.CONTACT_DETAILS) > -1 ? true : false;
        this.placardDetails = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.PLACARD_DETAILS) > -1 ? true : false;
        this.pickupDetails = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.PICKUP_DETAILS) > -1 ? true : false;
        this.notifications = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.NOTIFICATIONS) > -1 ? true : false;
        this.placardVerification = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.PLACARD_VERIFICATION) > -1 ? true : false;
        this.placardLocation = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.PLACARD_LOCATION) > -1 ? true : false;
        this.verificationNeeded = this.dashboardSections.findIndex(val => val === DASHBOARD_SECTIONS.VERIFICATION_NEEDED) > -1 ? true : false;
    }

    getURLPicture() {
        if (this.dashboardData.placardInformation != null && this.dashboardData.placardInformation != undefined) {
            if (this.dashboardData.placardInformation.placardVerification) {
                if (this.dashboardData.placardInformation.placardVerification.placardImage) {
                    this.urlImage = 'data:' + this.dashboardData.placardInformation.placardVerification.placardImage.extension + ';base64,' + this.dashboardData.placardInformation.placardVerification.placardImage.contents;
                }
            }
        }

    }

    public openPicture() {
        var newTab = window.open();
        newTab.document.body.innerHTML = '<img src="' + this.urlImage.trim() + '"' + ' width="80%" height="80%">';
    }

    getAndCompareContacts() {
        this.showRequestorContact = true;
        if (this.dashboardData.placardInformation != null && this.dashboardData.placardInformation != undefined) {
            if (this.dashboardData.placardInformation.contactDetails[0] != null && this.dashboardData.placardInformation.contactDetails[0] != undefined) {
                for (let i in this.dashboardData.placardInformation.contactDetails) {
                    if (this.dashboardData.placardInformation.contactDetails[i].contactType === '02') { //Primary Contact
                        this.primary.email = this.dashboardData.placardInformation.contactDetails[i].email;
                        this.primary.name = this.dashboardData.placardInformation.contactDetails[i].name;
                        this.primary.phone = this.dashboardData.placardInformation.contactDetails[i].phone;
                        this.primary.phoneExt = this.dashboardData.placardInformation.contactDetails[i].phoneExt;
                    }
                    else if (this.dashboardData.placardInformation.contactDetails[i].contactType === '01') { // Requestor Contact
                        this.requestor.email = this.dashboardData.placardInformation.contactDetails[i].email;
                        this.requestor.name = this.dashboardData.placardInformation.contactDetails[i].name;
                        this.requestor.phone = this.dashboardData.placardInformation.contactDetails[i].phone;
                        this.requestor.phoneExt = this.dashboardData.placardInformation.contactDetails[i].phoneExt;
                    }
                }
            }
        }

        if (this.primary.email === this.requestor.email && this.primary.name === this.requestor.name && this.primary.phone === this.requestor.phone && this.primary.phoneExt === this.requestor.phoneExt) {
            this.showRequestorContact = false;
        }
    }

    getMultiOffice() {
        if (this.dashboardData.placardInformation != undefined && this.dashboardData.placardInformation != null) {
            if (this.dashboardData.placardInformation.placardDetails != undefined && this.dashboardData.placardInformation.placardDetails != null) {
                if (this.dashboardData.placardInformation.placardDetails.locationType != undefined && this.dashboardData.placardInformation.placardDetails.locationType != null) {
                    this.MultiOffice = this.dashboardData.placardInformation.placardDetails.locationType === 'Single Location' ? 'No' : 'Yes';
                }
            }
        }
    }

    goToPlacardVerification() {
        this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_PLACARD_VERIFICATION_ROUTE + this.paramsUrl.concat(this.dashboardData.placardId));
    }
}